<template>
  <!-- 🌿 Banner -->
  <section class="pt-0">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div
            class="card overflow-hidden h-100px h-xl-200px rounded-3"
            style="
              background-image: url(/assets/images/bg/fondo-acercade-viaverde.jpg);
              background-position: center left;
              background-size: cover;
            "
          >
            <div class="bg-overlay bg-dark opacity-6"></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- 📰 Lista de noticias -->
  <div class="container my-4">
    <div v-if="newsStore.loading" class="text-center py-5">
      <div class="spinner-border text-success" role="status"></div>
      <p class="mt-2">Cargando noticias...</p>
    </div>

    <div v-else-if="newsStore.error" class="alert alert-danger">
      {{ newsStore.error }}
    </div>

    <div v-else>
      <div class="row g-4">
        <div v-for="item in newsStore.news" :key="item.id" class="col-12">
          <div class="card shadow overflow-hidden p-2">
            <div class="row g-0">
              <div class="col-md-4 overflow-hidden image-container">
                <img
                  :src="item.image_path || '/assets/images/placeholder.jpg'"
                  class="rounded-2 w-100 h-100"
                  :alt="item.title"
                  :title="item.title"
                  @click="goToDetail(item.id)"
                />
              </div>
              <div class="col-md-8">
                <div class="card-body">
                  <div
                    class="d-flex justify-content-between align-items-center mb-2"
                  >
                    <span class="badge text-bg-primary mb-2 mb-sm-0"
                      >Noticia</span
                    >
                    <div>
                      <span class="h6 fw-light me-3 fecha">
                        <i class="far fa-clock text-danger me-1"></i>
                        {{ formatDate(item.date) }}
                      </span>
                    </div>
                  </div>
                  <h5 class="card-title" @click="goToDetail(item.id)">{{ item.title }}</h5>
                  <p class="text-truncate-2 d-none d-lg-block resumen-noticia">
                    {{ item.summary }}
                  </p>
                  <div
                    class="d-sm-flex justify-content-sm-between align-items-center"
                  >
                    <div class="mt-3 mt-sm-0">
                      <button class="btn btn-dark" @click="goToDetail(item.id)">
                        Ver nota
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 🔄 Paginación -->
      <nav
        v-if="newsStore.totalPages > 1"
        class="mt-4 d-flex justify-content-center"
        aria-label="navigation"
      >
        <ul
          class="pagination pagination-primary-soft d-inline-block d-md-flex rounded mb-0"
        >
          <li
            class="page-item mb-0"
            :class="{ disabled: newsStore.currentPage === 1 }"
          >
            <button
              class="page-link"
              @click="newsStore.changePage(newsStore.currentPage - 1)"
            >
              <i class="fas fa-angle-double-left"></i>
            </button>
          </li>

          <li
            v-for="page in newsStore.totalPages"
            :key="page"
            class="page-item mb-0"
            :class="{ active: page === newsStore.currentPage }"
          >
            <button class="page-link" @click="newsStore.changePage(page)">
              {{ page }}
            </button>
          </li>

          <li
            class="page-item mb-0"
            :class="{
              disabled: newsStore.currentPage === newsStore.totalPages,
            }"
          >
            <button
              class="page-link"
              @click="newsStore.changePage(newsStore.currentPage + 1)"
            >
              <i class="fas fa-angle-double-right"></i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useNewsStore } from "@/modules/news/stores/news";

export default {
  setup() {
    const router = useRouter();
    const newsStore = useNewsStore();

    onMounted(() => {
      newsStore.fetchNews();
    });

    const goToDetail = (id) => {
      router.push({ name: "news-detail", params: { id } });
    };

    const formatDate = (date) => {
      if (!date) return "";
      const d = new Date(date + "T00:00:00");
      return d.toLocaleDateString("es-BO", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    };

    return { newsStore, goToDetail, formatDate };
  },
};
</script>

<style scoped>
  .badge{
font-family: "Montserrat";
  }
  .fecha{
  font-family: "Montserrat";
  } 
h5{
  font-family: "Merriweather";
}
.resumen-noticia{
  font-family: "Montserrat";
  text-align: justify;
}
button{
font-family: "Montserrat";
}
.card-title{
  cursor: pointer;
}
.image-container {
  width: 300px;
  height: 200px;
  margin-bottom: 25px;
}
.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

@media (max-width: 1365px) {
  .image-container {
    width: 100%;
    height: 200px;
    text-align: center;
  }
}
@media (max-width: 768px) {
  .image-container {
    margin-bottom: 10px;
  }
}
</style>
